import {
    createForm,
    createPrimitiveField,
    emailValidator,
    type InferFormValue,
    matchValidator,
    requiredValidator,
    type ValidationError,
} from '@adv-frontend/form-kit';
import { phoneValidator } from '@adv-frontend/yastore-modules/lib';
import { deliveryClientNameRegex } from '@/entities/order';
import { type ClientFormValidationErrorCode } from './type';

type FieldValidationError<T extends ClientFormValidationErrorCode> = ValidationError<T | 'REQUIRED_FIELD'>;

type ClientFormContext = {
    needPhoneVerification: boolean;
};

export const clientForm = createForm({
    name: 'OrderClientForm',
    fields: {
        firstName: createPrimitiveField({
            defaultValue: '',
            validators: (createValidators) =>
                createValidators<FieldValidationError<'INVALID_FIRST_NAME_FORMAT'>>({
                    onBlur: [
                        requiredValidator('REQUIRED_FIELD'),
                        matchValidator(deliveryClientNameRegex, 'INVALID_FIRST_NAME_FORMAT'),
                    ],
                }),
        }),
        lastName: createPrimitiveField({
            defaultValue: '',
            validators: (createValidators) =>
                createValidators<FieldValidationError<'INVALID_LAST_NAME_FORMAT'>>({
                    onBlur: [
                        requiredValidator('REQUIRED_FIELD'),
                        matchValidator(deliveryClientNameRegex, 'INVALID_LAST_NAME_FORMAT'),
                    ],
                }),
        }),
        phone: createPrimitiveField({
            defaultValue: '',
            validators: (createValidators) =>
                createValidators<FieldValidationError<'INVALID_PHONE_FORMAT'>>({
                    onBlur: [requiredValidator('REQUIRED_FIELD'), phoneValidator('INVALID_PHONE_FORMAT')],
                }),
        }),
        email: createPrimitiveField({
            defaultValue: '',
            validators: (createValidators) =>
                createValidators<FieldValidationError<'INVALID_EMAIL_FORMAT'>>({
                    onBlur: [requiredValidator('REQUIRED_FIELD'), emailValidator('INVALID_EMAIL_FORMAT')],
                }),
        }),
        phoneVerified: createPrimitiveField({ defaultValue: '' }),
    },
    context: (context: ClientFormContext) => {
        return { form: context };
    },
    onSubmit: async (values) => values,
});

export type ClientFormInput = InferFormValue<typeof clientForm>;
